<template>
  <div id="invite-page" class="mb-6 p-4">
  <div class="d-none d-xl-block d-xxl-block" style="margin-top: 2rem;"></div>
    <div class="row">
      <!-- Breadcrumbs -->
      <nav aria-label="breadcrumb" class="col-md-4 col-lg-4 col-sm-12 pt-2" style="padding-left: unset;">
        <ol class="breadcrumb align-middle">
          <li class="breadcrumb-item">
            <a :href="'/networks/' + network.slug + '/members'" class="text-primary fw-bold">
              {{ $t('network.tabMembers') }}
            </a>
          </li>
          <li class="breadcrumb-item">
            <a class="fw-bold pointer" :class="showParsedEmails ? 'text-primary' : 'text-secondary'" @click.prevent="showParsedEmails = false">
              {{ $t('network.member.addNewMembers') }}
            </a>
          </li>
          <li v-if="showParsedEmails" class="breadcrumb-item">
            <a class="text-secondary fw-bold">
              Confirm invites
            </a>
          </li>
        </ol>
      </nav>
      <div class="col-md-8 col-lg-8 col-sm-12" style="padding: inherit;" align="right">
        <div class="btn-group" role="group" :aria-label="$t('ResultMediaSection.basic-radio-toggle-button-group')">
          <button
            v-for="(option, index) in currentView.options"
            :id="'btnradio'+index"
            :key="index"
            :data-test="'btnradio'+index"
            role="button"
            :for="'btnradio'+index"
            :class="defineActiveTab(currentView.model, index)"
            class="btn btn-outline-primary"
            @click="currentView.model = option.value; /*option.value == 'invitation-link' ? generateInvitationLink() : ''*/"
          >
            <input :id="'btnradio'+index" v-model="currentView.model" :data-test="'btnradio'+index" type="radio" class="btn-check" name="btnradio" autocomplete="off" :value="option.value" />
            {{ option.text }}
          </button>
        </div>
      </div>
    </div>

    <div class="mt-4">
      <div v-if="currentView.model === 'paste-emails'">
        <form v-if="!showParsedEmails" method="POST" @submit.prevent="invite">
          <div>
            <label for="from">{{ $t('NetworkMessageForm.from') }}</label>
            <input id="from" v-model="form.from" data-test="from" type="text" class="form-control" />
          </div>
          <div class="mt-4">
            <h5>{{ $t('add-list-of-email-addresses') }}<sup class="text-danger ms-1">*</sup></h5>
            <h6 class="fw-medium" @click.prevent="showExamples = true"><a class="text-primary" href="#">({{ $t('network.member.seeExamples') }})</a></h6>
            <textarea
              id="emails"
              v-model="form.emails"
              data-test="emails"
              :placeholder="$t('add-list-of-email-addresses')"
              required
              rows="3"
              class="form-control w-100"
            ></textarea>
          </div>
          <div class="mt-4">
            <h5>{{ $t('write-a-customized-message-optional') }}</h5>
            <h6 class="fw-medium">{{ $t('a-personalized-message-which-will-be-sent-along-the-invitation') }}</h6>
            <b-form-textarea
              id="invite-msg"
              v-model="form.message"
              data-test="invite-msg"
              :placeholder="$t('write-message')"
              rows="3"
            ></b-form-textarea>
          </div>
          <div class="form-group">
            <span id="message-preview" data-test="message-preview" class="text-primary fs-sm fw-bold pointer" @click="message_preview = !message_preview, showMessagePreview()">
              {{ $t('network.messages.showMessagePreview') }}
            </span>
          </div>
          <div class="mt-4">
            <h5>{{ $t('network.message.attachedMediaOptional') }}</h5>
            <h6 class="fw-medium">{{ $t('select-any-media-from-networks-to-send-along-the-invitation') }}</h6>
            <NetworkMediaSelector :network="network" @media-selected="mediaSelectedEvent" />
          </div>

          <p class="mt-5 text-center">
            <button id="invite" data-test="invite" type="submit" class="btn btn-primary">{{ $t('network.member.invite') }}</button>
          </p>
        </form>

        <div v-if="showParsedEmails">
          <p class="fw-semibold">Please confirm the list of invitations to be sent.</p>
          <div class="row">
            <div class="col-8 px-0">
              <span v-if="(parsedEmailCategories.existingUser.length > 0 || parsedEmailCategories.inviteSentAlready.length > 0)"
              class="alert rounded-1 alert-warning text-black fw-semibold d-flex mb-0" style="font-size: medium;">
                <span v-if="parsedEmailCategories.existingUser.length > 0 && parsedEmailCategories.inviteSentAlready.length > 0">
                  <span v-if="parsedEmailCategories.existingUser.length == 1">
                    1 existing member of this network will be excluded from the list of invites.
                  </span>
                  <span v-else>
                    {{ parsedEmailCategories.existingUser.length }} existing members of this network will be excluded from the list of invites.
                  </span>
                  <span v-if="parsedEmailCategories.inviteSentAlready.length == 1">
                    1 email has previously received an invitation. You can remove it manually or by clicking the button on the right.
                  </span>
                  <span v-else>
                    {{ parsedEmailCategories.inviteSentAlready.length }} emails have previously received invitations.
                    You can remove them manually or all at once by clicking the button on the right.
                  </span>
                </span>
                <span v-else>
                  <span v-if="parsedEmailCategories.existingUser.length > 0 && parsedEmailCategories.inviteSentAlready.length == 0">
                    <span v-if="parsedEmailCategories.existingUser.length == 1">
                      1 existing member of this network will be excluded from the list of invites.
                    </span>
                    <span v-else>
                      {{ parsedEmailCategories.existingUser.length }} existing members of this network will be excluded from the list of invites.
                    </span>
                  </span>
                  <span v-if="parsedEmailCategories.existingUser.length == 0 && parsedEmailCategories.inviteSentAlready.length > 0">
                    <span v-if="parsedEmailCategories.inviteSentAlready.length == 1">
                      1 email has previously received an invitation. You can remove it manually or by clicking the button on the right.
                    </span>
                    <span v-else>
                      {{ parsedEmailCategories.inviteSentAlready.length }} emails have previously received invitations.
                      You can remove them manually or all at once by clicking the button on the right.
                    </span>
                  </span>
                </span>
              </span>
            </div>
            <div v-if="parsedEmailCategories.inviteSentAlready.length > 0" class="col-4 px-0" style="text-align-last: right; align-content: center;">
              <button class="btn btn-danger" style="padding: 0.425rem 1.7rem !important;" @click="removeInvites(parsedEmailCategories.inviteSentAlready)">
                Remove affected invites
              </button>
            </div>
          </div>
          <p v-if="(parsedEmailCategories.existingUser.length > 0 || parsedEmailCategories.inviteSentAlready.length > 0)" class="my-3">
            <span class="me-5"><i class="fa-solid fa-circle" style="color: #CCCCCC;"></i>&nbsp;Network member</span>
            <span><i class="fa-solid fa-circle" style="color: #90F0FF;"></i>&nbsp;Previously invited user</span>
          </p>
          <table class="table table-condensed text-center">
            <thead>
              <tr>
                <th>{{ $t('network.name') }}</th>
                <th>{{ $t('network.auth.email') }}</th>
                <th>{{ $t('network.member.status') }}</th>
                <th v-if="network.can.edit_member">{{ $t('network.member.admin') }}</th>
                <th v-if="network.can.edit_member">Industry</th>
                <th>{{ $t('network.member.action') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(email, i) in parsedEmails" :key="i"
              :style="{'background-color': email.category == 'User is already a member.' ? '#CCCCCC' : (email.category == 'User has already been invited.' ? '#90F0FF' : '')}">
                <td>
                  <input v-if="email.category != 'User is already a member.'" v-model="email.name" type="text" class="form-control" placeholder="Enter name" />
                </td>
                <td style="vertical-align: middle;">{{ email.email }}</td>
                <td style="vertical-align: middle;">
                  <span v-html="email.category"></span>&nbsp;
                  <i v-if="email.category === 'User has already been invited.'" class="fa-solid fa-circle-info fw-bold text-primary" @click="showInviteHistory(email)"></i>
                </td>
                <td v-if="network.can.edit_member" style="vertical-align: middle;">
                  <div v-if="email.category != 'User is already a member.'">
                    <label>
                      <input v-model="email.isAdmin" type="radio" :value="true" :name="'isAdmin' + i" />
                      {{ $t('ResearchCreds.yes') }}
                    </label><br>
                    <label>
                      <input v-model="email.isAdmin" type="radio" :value="false" :name="'isAdmin' + i" />
                      {{ $t('ResearchCreds.no') }}
                    </label>
                  </div>
                </td>
                <td v-if="network.can.edit_member" style="vertical-align: middle;">
                  <div :style="{ 'pointer-events': email.category != 'User not invited and not signed up.' ? 'none' : 'auto', 'cursor': email.category != 'User not invited and not signed up.' ? 'not-allowed' : 'pointer' }">
                    <label>
                      <input v-model="email.isIndustry" type="radio" :value="true" :name="'isIndustry' + i" />
                      {{ $t('ResearchCreds.yes') }}
                    </label><br>
                    <label>
                      <input v-model="email.isIndustry" type="radio" :value="false" :name="'isIndustry' + i" />
                      {{ $t('ResearchCreds.no') }}
                    </label>
                  </div>
                </td>
                <td style="vertical-align: middle;">
                  <a v-if="email.category != 'User is already a member.'" id="remove" data-test="remove" href="#" class="text-danger fw-bold" @click.prevent="parsedEmails.splice(i, 1)">
                    {{ $t('network.member.remove') }}
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="mb-3">
            <div>
              <span id="add_invite" data-test="add_invite" class="fw-semibold text-primary pointer" @click="showOneMoreInput = !showOneMoreInput">
                {{ $t('network.member.addOneMoreInvite') }}
              </span>
            </div>
          </div>
          <hr style="opacity: 1;" />
          <div v-if="!areEmailsInSameCategory() && !isSingleEmail()" class="mt-4 mb-3">
            <b-form-checkbox id="add_custom_message" v-model="customInviteMessage.show" data-test="add_custom_message">&nbsp;
              Add custom messages for different categories of users
            </b-form-checkbox>
            <span class="text-danger fw-bold fs-sm">Note: this will ovewrite any message defined in the previous screen for that specific category.</span>
            <div v-if="customInviteMessage.show" class="col-md-12">
              <div class="row mt-4 my-0">
                <b-form-group
                  v-if="parsedEmailCategories.inviteSentAlready.length > 0"
                  :label="'Already invited users (' + parsedEmailCategories.inviteSentAlready.length + ' users)'"
                  class="col-md-6 ps-0"
                >
                  <b-form-textarea id="invite_sent_already" v-model="customInviteMessage.inviteSentAlready" data-test="invite_sent_already" class="mb-3" :placeholder="form.message"></b-form-textarea>
                </b-form-group>
                <b-form-group
                  v-if="parsedEmailCategories.userExistsButNotInvited.length > 0"
                  :label="'Existing non-invited users (' + parsedEmailCategories.userExistsButNotInvited.length + ' users)'"
                  class="col-md-6 ps-0"
                >
                  <b-form-textarea id="user_exists_but_not_invited" v-model="customInviteMessage.userExistsButNotInvited" data-test="user_exists_but_not_invited" class="mb-3" :placeholder="form.message"></b-form-textarea>
                </b-form-group>
                <b-form-group
                  v-if="parsedEmailCategories.newInvite.length > 0"
                  :label="'New invitations (' + parsedEmailCategories.newInvite.length + ' users)'"
                  class="col-md-6 ps-0">
                  <b-form-textarea id="new_invite" v-model="customInviteMessage.newInvite" data-test="new_invite" class="mb-3" :placeholder="form.message"></b-form-textarea>
                </b-form-group>
              </div>
            </div>
          </div>
          <button id="submit_invitations" data-test="submit_invitations" :disabled="parsedEmails.length === parsedEmailCategories.existingUser.length" class="btn btn-primary" style="padding: 0.425rem 1.7rem !important;" @click="submitInvitations">
            {{ $t('send-invitations') }}
          </button>
        </div>
      </div>
      <div v-if="currentView.model === 'search-directory'">
        <h5 class="mb-2">{{ $t('network.networkForm.inviteUser') }}</h5>
        <b-form-checkbox v-if="network.can.edit_member" id="invite_as_admin" v-model="users.isAdmin" data-test="invite_as_admin" class="my-3">
          <h6>&nbsp;{{ $t('network.member.inviteAsAdmin') }}</h6>
        </b-form-checkbox>
        <b-form-checkbox v-if="network.can.edit_member" id="invite_as_industry" v-model="users.isIndustry" data-test="invite_as_industry" class="my-3">
          <h6>&nbsp;Invite as industry user</h6>
        </b-form-checkbox>
        <div class="mb-4">
          <v-select
            id="selected_users"
            v-model="users.selectedUserToInvite"
            data-test="selected_users"
            :options="users.filteredUsers"
            :get-option-label="option => option.first_name + ' ' + option.last_name"
            :placeholder="$t('network.member.searchExistingUsers')"
            @search="searchMembers"
          >
            <template v-slot:option="option">
              {{ option.first_name + ' ' + option.last_name }} - <b>{{ option.email }}</b>
            </template>
          </v-select>
        </div>
      </div>
      <div v-if="currentView.model === 'invitation-link'">
        <h5 class="my-4">Share this link to invite anyone to the {{ network.short_name }} Network</h5>
        <div class="my-4">
          <b-input-group class="mt-3">
            <b-form-input id="invitation-link-text" data-test="invitation-link-text" :value="invitationLink" readonly></b-form-input>
            <b-input-group-append>
              <b-button variant="primary" style="border-top-left-radius: 0; border-bottom-left-radius: 0;" @click="doCopy">
                {{ invitationLinkBtnText.toUpperCase() }}
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <span class="text-muted">{{ $t('network.member.thisLinkWillBeActive') }}</span>
      </div>
    </div>

    <Modal :show.sync="showExamples" :title="$t('network.member.exampleEmailAddresses')">
      <p>{{ $t('network.member.examples') }}</p>
      <pre>
        mary1@example.net,
        Mary R &lt;mary.r@example.net&gt;,
        "Mary Ramone" &lt;mary.ramone@example.net&gt;,
        {{ $t('network.member.groupEmailList') }} &lt;group@example.net&gt;
        email1@gmail.com; email2@gmail.com; email3@gmail.com
      </pre>
      <p v-html="$t('emails-can-be-split-via-commas-or-semi-colons-or-even-new-lines')"></p>
      <span>{{ $t('network.member.thisInputSupports') }}</span>
    </Modal>
    <b-modal
      id="messagePreviewModal"
      size="lg"
      hide-footer
      hide-header
      body-class="p-0"
      @hide="message_preview = false"
    >
      <h5 class="float-start fw-bold m-3 modal-title">{{ $t('network.messages.networkMessagePreview') }}</h5>
      <span role="button" class="close float-end fs-4 m-3" @click="$bvModal.hide('messagePreviewModal')">
        <span aria-hidden="true"><i class="fa fa-times"></i></span>
      </span>
      <p v-html="message_preview_html"></p>
    </b-modal>
    <b-modal v-model="showOneMoreInput" title="Add New Invite" hide-footer>
      <div class="text-center p-2">
        <input id="email" v-model="oneMoreInputEmail" data-test="email" class="form-control" :placeholder="$t('network.member.enterEmail')" />
        <button id="add_more" data-test="add_more" class="btn btn-primary mt-4" style="padding: 0.425rem 1.7rem !important;" @click="inviteOneMore()">
          {{ $t('network.member.add') }}
        </button>
      </div>
    </b-modal>
    <b-modal v-model="showInviteModal" hide-footer hide-header size="lg">
      <InviteDetailsModal :network_slug="network.slug" :invite="selectedMemberInvite" :showHistory="true" @closeInviteModal="showInviteModal = false, selectedMemberInvite = {}" />
    </b-modal>
  </div>
</template>
<script>
import NetworkMediaSelector from '@/components/commons/Media/Selector.vue';
import InviteDetailsModal from './InviteDetailsModal.vue';
import Modal from '@/components/commons/Modals/Modal.vue';
import debounce from 'lodash/debounce';
import emailParser from 'email-addresses';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  components: {
    NetworkMediaSelector,
    InviteDetailsModal,
    Modal,
    vSelect,
  },
  props: {
    network: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      customInviteMessage: {
        show: false,
        existingUser: '',
        inviteSentAlready: '',
        userExistsButNotInvited: '',
        newInvite: '',
      },
      message_preview: false,
      message_preview_html: '',
      oneMoreInputEmail: '',
      showOneMoreInput: false,
      showExamples: false,
      showParsedEmails: false,
      invitedMembers: [],
      selectedMemberInvite: {},
      showInviteModal: false,
      invitationLink: null,
      invitationLinkBtnText: this.$t('Invite.copy'),
      users: {
        filteredUsers: [],
        isAdmin: false,
        isIndustry: false,
        selectedUserToInvite: null,
      },
      form: {
        emails: [],
        message: '',
        from: 'Resonance Networks',
      },
      parsedEmails: [],
      currentView: {
        options: [
          { text:  this.$t('pasteEmails'), value: 'paste-emails' },
          { text:  this.$t('network.member.searchDirectory'), value: 'search-directory' },
          //{ text: this.$t('network.member.invitationLinkTabTitle'), value: 'invitation-link' },
        ],
        model: 'paste-emails',
      },
    };
  },
  computed: {
    parsedEmailCategories() {
      return {
        existingUser: this.parsedEmails.filter(em => em.category === 'User is already a member.'),
        inviteSentAlready: this.parsedEmails.filter(em => em.category === 'User has already been invited.'),
        userExistsButNotInvited: this.parsedEmails.filter(em => em.category === 'User exists in other network.'),
        newInvite: this.parsedEmails.filter(em => em.category === 'User not invited and not signed up.'),
      };
    },
  },
  watch: {
    'users.selectedUserToInvite': function (newVal) {
      if (newVal && 'email' in newVal) this.inviteMemberToGroup([{ name: '', email: newVal.email, isAdmin: this.users.isAdmin, isIndustry: this.users.isIndustry }]);
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$http.get('networks/' + this.network.slug + '/all-invites').then(resp => {
        this.invitedMembers = resp.data;
      });
    },
    inviteOneMore() {
      let newInvite = [];
      newInvite = this.parseEmailsFromText(this.oneMoreInputEmail);
      newInvite[0].category = '<i class="fa-solid fa-spinner"></i>';

      let emails = newInvite.map(e => e.email);
      this.$http.post('networks/' + this.network.slug + '/members/invite-category', { emails }).then(resp => {
        newInvite[0].category = resp.data[0].category;
        newInvite[0].isAdmin = resp.data[0].isAdmin;
        newInvite[0].isIndustry = resp.data[0].isIndustry;
      });
      this.parsedEmails.push(newInvite[0]);
      this.oneMoreInputEmail = '';
      this.showOneMoreInput = false;
    },
    mediaSelectedEvent(media) {
      this.form.attached_media_id = media.id;
    },
    // Converts newlines and semi colons to commas
    sanitize(emails) {
      emails = emails.replace(/\n/g, ',').replace(/;/g, ',').replace(/\(/g, '<').replace(/\)/g, '>');
      return emails.split(',');
    },
    // use a magic email address extractor regex to find emails in a text
    extractRawEmails(value) {
      value = value.toLowerCase();
      const reg = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;
      var emails = value && value.match(reg);
      if (emails) {
        // remove quotes from the emails (if present)
        for (var i in emails) {
          var email = emails[i];
          if (email.charAt(0) == '"' || email.charAt(0) == "'") {
            emails[i] = email.substr(1);
          }
        }
      }
      return emails;
    },
    /**
     * Main parse routine to extract the email addresses from user's input. The stategy we follow is as follows:
     *
     * 1) First we use a wellknown regexp to extract any and all text that look like an email address. This ensures that we can 'add them back' in case the main parse routine fails.
     * 2) Use our standard RFC522 (email-addresses) node pkg to parse the rest of the text. This will extract emails + names
     * 3) Also removes duplicates
     */
    parseEmailsFromText(txt) {
      var rawExtractedEmails = this.extractRawEmails(txt);
      var emails = this.sanitize(txt);
      var parsedEmails = [];
      let duplicateList = [];

      if (emails.length == 0) {
        return this.$bvModal.msgBoxOk(this.$t('Invite.no-email-addresses-found-in-the-input'));
      }

      for (var email of emails) {
        var r = emailParser.parseOneAddress({
          input: email,
          simple: true,
          partial: true,
        });
        var found = false;
        if (r) {
          var addressString = r.address.toLowerCase().trim();
          var firstChar = addressString.charAt(0);
          var lastChar = addressString.charAt(addressString.length - 1);
          if ((firstChar == "'" && lastChar == "'") || (firstChar == '"' && lastChar == '"')) {
            addressString = addressString.substr(1, addressString.length - 2);
          }
          // check if the address has quotes around them
          found = { name: r.name, email: addressString };
          // check for a
        } else {
          // try one more time in the non-simple mode
          r = emailParser.parseOneAddress({ input: email });
          // This returns a full parsed result
          if (r && r.type == 'mailbox') {
            found = { name: r.name, email: r.address.toLowerCase() };
          }
        }

        if (found) {
          // add to parsedEmails array, but also see if we found in raw, and remove it from there
          if (!this.checkForDuplicatesInParsedEmails(parsedEmails, found.email)) {
            parsedEmails.push(found);
            var indexToRemove = rawExtractedEmails.indexOf(found.email);
            if (indexToRemove !== -1) rawExtractedEmails.splice(indexToRemove, 1);
          } else {
            duplicateList.push(found.email);
          }
        }
      }

      // at this point rawExtractedEmails should contain everything we need to know about (which were not parsed by the rfc parser)
      for (let email of rawExtractedEmails) {
        if (!this.checkForDuplicatesInParsedEmails(parsedEmails, email)) {
          parsedEmails.push({
            name: '',
            email,
          });
        } else {
          duplicateList.push(email);
        }
      }

      if (duplicateList.length > 0) {
        this.$swal.fire({
          icon: 'info',
          title: this.$t('network.invite.requestToInviteModeration', {
            defaultValue: 'Some of your emails were duplicates and were automatically removed. Duplicate emails: {{ emails }}',
            emails: duplicateList.join(', ')
          }) ,
        });
      }
      return parsedEmails;
    },
    // simple function that returns true if the given email exists in the list of parsed emails
    checkForDuplicatesInParsedEmails(parsedEmails, email) {
      var result = parsedEmails.map(el => el.email).find(em => em.trim().toLowerCase() === email.trim().toLowerCase());
      // if the map result is undefined, no duplicates were found
      if (result == undefined) return false;
      return true;
    },
    invite() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      this.parsedEmails = this.parseEmailsFromText(this.form.emails);
      if (this.parsedEmails.length > 0) {
        let emails = this.parsedEmails.map(e => e.email);
        this.$http.post('networks/' + this.network.slug + '/members/invite-category', { emails }).then(resp => {
          for (let i in this.parsedEmails) {
            this.parsedEmails[i].category = resp.data[i].category;
            this.parsedEmails[i].isAdmin = resp.data[i].isAdmin;
            this.parsedEmails[i].isIndustry = resp.data[i].isIndustry;
          }
          this.showParsedEmails = true;
        });
      } else {
        this.$bvModal.msgBoxOk(
          this.$t('network.member.weCouldNotFind') +
            '.' +
            this.$t('network.member.pleaseCheckInput') +
            '.'
        );
      }
    },
    submitInvitations() {
      this.busy = true;
      this.inviteMemberToGroup(this.parsedEmails, this.customInviteMessage);
    },
    inviteMemberToGroup(emails, customMessages = null) {
      let msg = this.$t('network.member.doYouWantToConfirmInvites') + '?';
      let action = () => {
        this.$http
          .post('networks/' + this.network.slug + '/members/invite', {
            from: this.form.from || null,
            email_addresses: emails,
            message: this.form.message,
            attached_media_id: this.form.attached_media_id || null,
            custom_messages: customMessages,
          })
          .then(() => {
            this.busy = false;
            this.showParsedEmails = false;
            this.$swal.fire({
              icon: 'success',
              title: this.$t('invitations-sent-successfully'),
              showCancelButton: false,
            });
          });
        this.form.emails = '';
        this.form.message = '';
        this.users.selectedUserToInvite = null;
      };
      this.showConfirmPrompt(action, msg);
    },
    searchMembers: debounce(function (searchQuery) {
      if (searchQuery.length === 0) {
        return;
      }
      this.$http
        .get('members/search', {
          params: {
            query: searchQuery,
            network_id: this.network.id,
            limit: 30,
          },
        })
        .then(resp => {
          this.users.filteredUsers = resp.data;
        });
    }, 600),
    generateInvitationLink() {
      if (!this.invitationLink) {
        this.$http.post('networks/' + this.network.slug + '/members/create-invitation-link').then(resp => {
          this.invitationLink = resp.data.link;
        });
      }
    },
    doCopy: function () {
      var copyText = document.getElementById('invitation-link-text');
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand('copy');
      this.invitationLinkBtnText = this.$t('Invite.copied');
    },
    defineActiveTab(model, index){
      if (model == 'paste-emails' && index==0 ||
          model == 'search-directory' && index==1 ||
          model == 'invitation-link' && index==2) {
        return 'active';
      }
    },
    showMessagePreview() {
      this.$http.post('networks/' + this.network.slug + '/invites/preview', this.form).then(resp => {
        this.message_preview_html = resp.data;

        if (this.message_preview) {
          this.$bvModal.show('messagePreviewModal');
        } else {
          this.$bvModal.hide('messagePreviewModal');
        }
      });
    },
    removeInvites(invites) {
      this.$swal.fire({
        title: this.$t('NetworkForm.are-you-sure-you-want-to-delete-these-invites'),
        input: 'text',
        inputLabel: this.$t('Showtype-delete-to-proceed'),
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-danger mx-1',
          cancelButton: 'btn btn-primary mx-1',
        },
        inputValidator: (value) => {
          if (!value) {
            return this.$t('you-need-to-write-something')
          }
          if (value != 'DELETE') {
            return this.$t('wrong-input')
          }
          if (value === 'DELETE') {
            this.parsedEmails = this.parsedEmails.filter(parsedEmail => {
              return !invites.some(invite => invite.email === parsedEmail.email);
            });
          }
        }
      });
    },
    isSingleEmail() {
      let totalEmails = 0;
      for (let category in this.parsedEmailCategories) {
        totalEmails += this.parsedEmailCategories[category].length;
      }
      return totalEmails === 1;
    },
    areEmailsInSameCategory() {
      let categories = new Set();
      for (let category in this.parsedEmailCategories) {
        for (let emailObj of this.parsedEmailCategories[category]) {
          categories.add(emailObj.category);
        }
      }
      return categories.size === 1;
    },
    showInviteHistory(user) {
      this.selectedMemberInvite = this.invitedMembers.find(m => m.email == user.email);
      this.showInviteModal = true;
    },
  },
};
</script>
<style scoped>
#invite-page .card-header {
  background-color: transparent;
}
.notification {
  font-size: 14px;
  padding: 7px;
  background: rgba(217, 217, 217, 1);
  color: #5c6d80 !important;
}
</style>
